import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  makeStyles,
  createStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";
import {
  Popover,
  Typography,
  Button,
  ListItem,
  List,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import CancelIcon from "@material-ui/icons/Cancel";
import SendIcon from "@material-ui/icons/Send";
import TextField from "@material-ui/core/TextField/TextField";
import { withSnackbar, useSnackbar } from "notistack";
import CloseIcon from "@material-ui/icons/Close";
import { linkToVoting } from "../Routes/var_PATHS";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btnStyles: {
      minHeight: 48,
      border: `2px solid ${theme.palette.secondary.main}`,
      boxSizing: "border-box",
      boxShadow: `0px 0px 4px ${theme.palette.secondary.main}`,
      // backgroundColor: `${theme.palette.error.main}20`,
      borderRadius: 25,
      transition: "0.2s ease-in-out",
      "&:hover": {
        boxShadow: `0px 0px 10px ${theme.palette.secondary.main}`,
      },
    },

    btnStylesWithOutline: {
      minHeight: 48,
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.paper,

      borderRadius: 25,
      boxSizing: "border-box",
      boxShadow: `0px 0px 2px ${theme.palette.primary.main}`,
      transition: "0.2s ease-in-out",
      "&:hover": {
        backgroundColor: theme.palette.background.paper,
        boxShadow: `0px 0px 10px ${theme.palette.primary.main}`,
      },
    },
  })
);

function RejectBulletinBtnWithReason(props: any) {
  const classes = useStyles();
  const theme = useTheme();

  const { t } = useTranslation();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const cancelAction = () => {
    return (
      <IconButton onClick={() => closeSnackbar()}>
        <CloseIcon fontSize="small" />
      </IconButton>
    );
  };

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    handleModalClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState("");

  const rejectSignupReq = () => {
    try {
      const req = {
        cancelReason: message,
        hashId: props.hashId,
      };
      props.handleReject(req);
      handleClose();
      linkToVoting()
    } catch (err) {
      enqueueSnackbar(err.toString(), {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
        action: cancelAction,
      });
    }
  };

  const handleChange = (e: any) => {
    setMessage(e.target.value);
  };

  const handleClickOpen = () => {
    setOpenModal(true);
    // console.log("open : ", open);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleReject = () => {
    handleClickOpen();
  };

  return (
    <div>
      <Button
        className={classes.btnStyles}
        // className={classes.btnStylesWithOutline}
        style={{ minWidth: 220, margin: "10px 0px" }}
        // variant="contained"
        // color="secondary"
        onClick={handleClick}
        // startIcon={<BlockIcon />}
        // onClick={() => props.handleDeleteLicence(props.hashId)}
      >
        {/* <Typography color="textPrimary"> {t("btns.reject")}</Typography> */}
        <Typography color="textPrimary">Скасувати</Typography>
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List>
          <ListItem>
            <Grid container justify="center">
              <Typography variant="caption" align="center" color="error">
                {t("btns.rejectQuestion")}
              </Typography>
            </Grid>
          </ListItem>
          <Grid container direction="row" justify="space-around">
            <Button
              className={classes.btnStyles}
              size="small"
              variant="text"
              onClick={handleReject}
            >
              {t("btns.yes")}
            </Button>

            <Button
              className={classes.btnStyles}
              size="small"
              variant="text"
              onClick={handleClose}
            >
              {t("btns.no")}
            </Button>
          </Grid>
        </List>
      </Popover>

      <Grid container item xs={12} justify="center">
        <Dialog
          maxWidth="lg"
          BackdropProps={{
            classes: {
              root: classes.backDrop,
            },
            timeout: 400,
          }}
          open={openModal}
          // onClose={handleModalClose}
          aria-labelledby="form-dialog-title"
        >
          {/* <DialogTitle id="form-dialog-title">{t("help.label")}</DialogTitle> */}
          <DialogTitle
            id="form-dialog-title"
            style={{
              backgroundColor: theme.palette.grey[900],
            }}
          >
            {t("requests.rejectUserWithReason")}
          </DialogTitle>
          <DialogContent
            dividers={true}
            style={{
              backgroundColor: theme.palette.grey[900],
            }}
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            <TextField
              // label={''}
              autoFocus
              name="reason"
              fullWidth
              margin="dense"
              variant="outlined"
              multiline
              rows={1}
              rowsMax="10"
              value={message}
              onChange={(e: any) => handleChange(e)}

              // inputProps={{ disabled: true }}
            />
          </DialogContent>
          <DialogActions
            style={{
              backgroundColor: theme.palette.grey[900],
            }}
          >
            <Grid container item xs={12} justify="space-between">
              <Grid>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  color="primary"
                  startIcon={<CancelIcon />}
                  style={{ minWidth: 180, margin: "5px 0px" }}
                >
                  <Typography>{t("btns.cancel")}</Typography>
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="contained"
                  onClick={rejectSignupReq}
                  color="primary"
                  startIcon={<SendIcon />}
                  style={{ minWidth: 180, margin: "5px 0px" }}
                >
                  <Typography>{t("btns.send")}</Typography>
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
}
export default withSnackbar(RejectBulletinBtnWithReason);
